import { Link } from 'react-router-dom';
import { Mail, Headphones } from 'lucide-react';
import Logo from '../ui/Logo';
import styles from './Footer.module.css';

function FooterWordmark() {
  return <Logo size={26} />;
}

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        {/* Top grid — all columns on same row */}
        <div className={styles.grid}>

          {/* Brand */}
          <div className={styles.brand}>
            <div className={styles.brandMark}>
              <FooterWordmark />
            </div>
            <p className={styles.mission}>
              The AI Agent Marketplace. Discover, buy, and sell autonomous AI agents
              built by developers around the world.
            </p>
            <div className={styles.socials}>
              <a href="https://instagram.com/aiphra" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={styles.social}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.012-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a href="https://discord.gg/aiphra" target="_blank" rel="noopener noreferrer" aria-label="Discord" className={styles.social}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057c.003.022.015.04.032.052a19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03z"/></svg>
              </a>
            </div>
          </div>

          {/* Platform */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Platform</h4>
            <Link to="/explore" className={styles.colLink}>Explore Products</Link>
            <Link to="/pricing" className={styles.colLink}>Pricing & Plans</Link>
            <Link to="/docs" className={styles.colLink}>Documentation</Link>
            <Link to="/sellers" className={styles.colLink}>Seller Guide</Link>
          </div>

          {/* Sellers */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Sellers</h4>
            <Link to="/signup" className={styles.colLink}>Start Selling Free</Link>
            <Link to="/dashboard" className={styles.colLink}>Seller Dashboard</Link>
            <Link to="/support" className={styles.colLink}>Seller Support</Link>
          </div>

          {/* Support */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Support</h4>
            <Link to="/support" className={styles.colLink}>Help Center</Link>
            <Link to="/support#buyers" className={styles.colLink}>Buyer Support</Link>
            <Link to="/support#sellers" className={styles.colLink}>Seller Support</Link>
            <a href="mailto:support@aiphra.com" className={styles.colLink}>support@aiphra.com</a>
          </div>

          {/* Legal */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Legal</h4>
            <Link to="/terms"         className={styles.colLink}>Terms of Service</Link>
            <Link to="/privacy"       className={styles.colLink}>Privacy Policy</Link>
            <Link to="/aup"           className={styles.colLink}>Acceptable Use</Link>
            <Link to="/refund-policy" className={styles.colLink}>Refund Policy</Link>
            <Link to="/dmca"          className={styles.colLink}>DMCA / Copyright</Link>
            <a href="mailto:abuse@aiphra.com" className={styles.colLink}>Report abuse</a>
          </div>
        </div>

        {/* Contact bar */}
        <div className={styles.contactBar}>
          <div className={styles.contactItem}>
            <span className={styles.contactIcon}><Mail size={16} strokeWidth={1.5}/></span>
            <div>
              <div className={styles.contactLabel}>General</div>
              <a href="mailto:hello@aiphra.com" className={styles.contactValue}>hello@aiphra.com</a>
            </div>
          </div>
          <div className={styles.contactItem}>
            <span className={styles.contactIcon}><Headphones size={16} strokeWidth={1.5}/></span>
            <div>
              <div className={styles.contactLabel}>Support</div>
              <a href="mailto:support@aiphra.com" className={styles.contactValue}>support@aiphra.com</a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className={styles.bottom}>
          <span className={styles.copy}>© 2026 Aiphra Inc. All rights reserved.</span>
          <div className={styles.bottomLinks}>
            <Link to="/terms" className={styles.bottomLink}>Terms</Link>
            <Link to="/privacy" className={styles.bottomLink}>Privacy</Link>
            <Link to="/support" className={styles.bottomLink}>Support</Link>
          </div>
          <span className={styles.stripe}>⚿ All transactions secured by Stripe</span>
        </div>
      </div>
    </footer>
  );
}
